import axios, {AxiosResponse} from 'axios'

class MapService {
  static getAddress<T>(at: string, api_key: string): Promise<T> {
    return axios
      .get(`https://revgeocode.search.hereapi.com/v1/revgeocode`, {
        params: {at, apiKey: api_key},
      })
      .then((response: AxiosResponse<T>) => response.data)
      .catch(err => {
        // eslint-disable-next-line
        console.log(err)
        throw new Error('Failed to get the address details')
      })
  }
}

export default MapService
